<template>
  <div>
    <header class="header">
      <h1 class="header__title">Account Settings</h1>
      <section class="header__area">
        <!--<button class="header__button button button--primary">Save Changes</button> -->
      </section>
    </header>

    <nav class="tabs">
      <router-link @click.native="current = ''" to="" class="tabs__tab tab" :class="{'tab--active': (current === '')}" >General</router-link>
      <router-link @click.native="current = 'account'" to="#account" class="tabs__tab tab" :class="{'tab--active': current === 'account'}" >Account</router-link>
    </nav>

    <section class="main-content main-content--white-background">
      <section class="main-content__full section">
        <profile-general v-if="current == ''" :name="name" :email="email"></profile-general>
        <profile-account v-if="current == 'account'" :plan_id="plan_id" :billing="billing" :planTerm="planTerm" :currentAccount="currentAccount"></profile-account>
      </section>
    </section>

  </div>

</template>

<script>
import store from '../store'
import ProfileAccount from '../components/ProfileAccount'
import ProfileGeneral from '../components/ProfileGeneral'
import _ from 'lodash'

export default {
  name: 'Profile',
  components: {
    ProfileAccount,
    ProfileGeneral
  },
  mounted(){
    if (this.$route.hash.slice(1)) {
      this.current = this.$route.hash.slice(1);
    }
    if (!localStorage.account_id) {
      this.$router.push('/');
    }
    this.plan_id = this.$store.state.account.plan_id;
    this.billing.id = this.$store.state.account.id;
    this.billing.plan = this.$store.state.account.plan;
    this.billing.last4 = this.$store.state.account.card_last_4;
    this.billing.cardType = this.$store.state.account.card_type;
    this.billing.exp = [this.$store.state.account.card_exp_month, this.$store.state.account.card_exp_year].join('/')
    this.name = this.$store.state.me.name;
    this.email = this.$store.state.me.email;
    this.$store.subscribe(function(mutation, state){
      if(state.me.name) this.name = state.me.name;
      if(state.me.email) this.email = state.me.email;
      if(state.account.id){
        this.currentAccount = state.account;
        this.planTerm = state.account.plan.term;
        this.billing = _.extend(this.billing, {
          id: state.account.id,
          plan: state.account.plan,
          plan_id: state.account.plan_id,
          last4: state.account.card_last_4,
          cardType: state.account.card_type,
          exp: [state.account.card_exp_month, state.account.card_exp_year].join('/')
        })
      }
    }.bind(this));
  },
  data () {
    return {
      name: '',
      email: '',
      billing: {
        plan: {},
        plan_id: null,
        token: null,
        dirty: false,
        last4: null,
        cardType: null,
        newCard: false,
      },
      currentAccount: null,
      planTerm: 'month',
      current: '',
      plan_id: null
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Profile.vue